import { render, staticRenderFns } from "./BloodTestsList.vue?vue&type=template&id=7f18208a&"
import script from "./BloodTestsList.vue?vue&type=script&lang=js&"
export * from "./BloodTestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports